import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/yuancao.jpg';
const _hoisted_1 = {
  key: 0,
  class: "PopupFollowOfficialAccounts"
};
const _hoisted_2 = {
  class: "btn"
};
const _hoisted_3 = {
  key: 1,
  class: "PopupFollowOfficialAccounts"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonSubmit = _resolveComponent("ButtonSubmit");
  const _component_PopupContainer = _resolveComponent("PopupContainer");
  return _openBlock(), _createBlock(_component_PopupContainer, {
    popupParams: _ctx.popupParams,
    popupService: _ctx.popupService
  }, {
    default: _withCtx(() => [_ctx.mode === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("p", {
      class: "text-color-danger"
    }, "新用户注册后1小时内限时关注公众号免费查看，长按二维码关注", -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "service-img"
    }, [_createElementVNode("img", {
      src: _imports_0,
      alt: "原草网公众号",
      width: "240",
      height: "240"
    })], -1)), _cache[3] || (_cache[3] = _createElementVNode("p", null, [_createTextVNode(" 长按二维码关注，或"), _createElementVNode("a", {
      href: "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA4MTkzODk0NA==&scene=110#wechat_redirect"
    }, "点击此处(原草互助)"), _createTextVNode("关注 ")], -1)), _cache[4] || (_cache[4] = _createElementVNode("p", {
      class: "tips"
    }, "若已关注，还提示未关注，请取消关注，再关注即可", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_ButtonSubmit, {
      round: "",
      click: _ctx.handleClose
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("不需要，关闭", -1)]))]),
      _: 1
    }, 8, ["click"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("p", {
      class: "text-color-danger"
    }, "您未关注【原草互助】公众号，关注后才能查看！", -1)), _createElementVNode("p", null, "关注后，获得优先特权：获取" + _toDisplayString(_ctx.modelDispalyName) + "信息推送！", 1), _cache[6] || (_cache[6] = _createElementVNode("p", null, "按行业、按地区精准推送，可设定关闭推送！", -1)), _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "service-img"
    }, [_createElementVNode("img", {
      src: _imports_0,
      alt: "原草网公众号",
      width: "240",
      height: "240"
    })], -1)), _cache[8] || (_cache[8] = _createElementVNode("p", null, [_createTextVNode(" 长按二维码关注，或"), _createElementVNode("a", {
      href: "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA4MTkzODk0NA==&scene=110#wechat_redirect"
    }, "点击此处(原草互助)"), _createTextVNode("关注 ")], -1)), _cache[9] || (_cache[9] = _createElementVNode("p", {
      class: "tips"
    }, "若已关注，还提示未关注，请取消关注，再关注即可", -1))]))]),
    _: 1
  }, 8, ["popupParams", "popupService"]);
}